import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  url,
  image,
  keywords = "",
  robots = "index, follow",
  schema
}) => {
  const websiteUrl = "https://www.tiara.software";
  const ogImage = image || `${websiteUrl}/bannerCard.jpg`;

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Tiara Software" />
      <meta name="publisher" content="Tiara Software" />
      <meta name="language" content="English" />
      <meta name="robots" content={robots} />
      <meta name="theme-color" content="#00c3ff" />

      {/* Canonical */}
      {url && <link rel="canonical" href={url} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Tiara Software" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      {url && <meta property="og:url" content={url} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Organization Schema */}
      {/* Page Specific Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;